// extracted by mini-css-extract-plugin
module.exports = {"status":"styles_status__3dU0m","required":"styles_required__2nQY8","answered":"styles_answered__3JJyF"};